import * as firebase from "firebase";
import i18n from "@/i18n"

const firebaseDatabase = {
    data() {
        return {
            liveUsers: null,
        }
    },

    methods: {
        incrementCounterOnFBase(screenerId) {
            return firebase
                .database()
                .ref("live_counter")
                .child(screenerId)
                .child("counter")
                .set(firebase.database.ServerValue.increment(1))
                .then(function(snapshot) {
                    // _this.liveUsers = snapshot.val();
                })
                .catch((error) => {
                    console.error('Firebase error ==>',error);
                });
        },

        decrementCounterOnFBase(screenerId) {
            let counter_value = this.liveUsers > 0 ?(this.liveUsers - 1) : 0;
            return firebase
                .database()
                .ref("live_counter")
                .child(screenerId)
                .child("counter")
                .set(counter_value)
                .then(function(snapshot) {
                    // _this.liveUsers = snapshot.val();
                })
                .catch((error) => {
                    console.error('Firebase error ==>',error);
                });
        },

        async bindLiveCounterWithFBase(screenerId) {
            let _this = this
            firebase.database().ref(`/live_counter/${screenerId}/counter`).on('value', function(snapshot) {
                _this.liveUsers = snapshot.val();
            })
        },

        async bindSessionWithFBase(consumerId) {
            let _this = this
            firebase.database().ref(`/consumer_sessions/${consumerId}`).on('value', function(snapshot) {
                let currentSessionKey = _this.$store.getters['auth/getSession'].key;
                let activeSessionKey = snapshot.val();
                /**
                 * Logout if following condition meets
                 * 1. Current session is available (Client side session)
                 * 2. Active session is available (Firebase side session)
                 * 3. If keys of CurrentSession and ActiveSession mismatched
                 */
                if(currentSessionKey && activeSessionKey && (activeSessionKey != currentSessionKey)){
                    _this.$store.dispatch ('auth/logout');
                    _this.$store.dispatch("app/showMessage", {
                        message: i18n.t('session.expired.message'),
                        color: "error",
                    });
                }
            })
        }
    }
}

export {
    firebaseDatabase
}
